import "./player.css";
function Players1() {
  return (
    <div className="player1">
      <h1 className="play1">player1</h1>
      <div className="diedpiece tile">died pieces</div>
    </div>
  );
}

export default Players1;
